/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface ResultDtoOfBoolean
 */
export interface ResultDtoOfBoolean {
    /**
     * 
     * @type {boolean}
     * @memberof ResultDtoOfBoolean
     */
    result?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResultDtoOfBoolean
     */
    $type?: ResultDtoOfBooleanTypeEnum;
}


/**
 * @export
 */
export const ResultDtoOfBooleanTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoResultDto1SystemBooleanSystemPrivateCoreLibPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ResultDto`1[[System.Boolean, System.Private.CoreLib]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ResultDtoOfBooleanTypeEnum = typeof ResultDtoOfBooleanTypeEnum[keyof typeof ResultDtoOfBooleanTypeEnum];


/**
 * Check if a given object implements the ResultDtoOfBoolean interface.
 */
export function instanceOfResultDtoOfBoolean(value?: unknown): value is ResultDtoOfBoolean {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ResultDtoOfBooleanTypeEnum)[0];
}

export function ResultDtoOfBooleanFromJSON(json: any): ResultDtoOfBoolean {
    return ResultDtoOfBooleanFromJSONTyped(json, false);
}

export function ResultDtoOfBooleanFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultDtoOfBoolean {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': !exists(json, 'result') ? undefined : json['result'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ResultDtoOfBooleanToJSON(value?: ResultDtoOfBoolean | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'result': value.result,
        '$type': value.$type,
    });
}

